export class TrackingEntities {
  static ACCOUNTS = 'accounts';

  static BOOKINGS = 'bookings';

  static INVOICES = 'invoices';

  static USER_PROFILES = 'user_profiles';

  static INSURANCE_PROFILES = 'insurance_profiles';
  static LAB_RESULTS = 'lab_results';
}

export class TrackingTypes {
  static ACTION_ONBOARD = 'action.onboard';

  static ACTION_REDIRECT = 'action.redirect';

  static CLICK_EMAIL = 'click.email';

  static CLICK_SMS = 'click.sms';

  static CLICK_TILE = 'click.tile';

  static CLICK_PUSH = 'click.push';

  static INFO_REFERRER = 'info.referrer';
}

export class UtmSourceTypes {
  static GMB = 'gmb';

  static GOOGLE_RESERVE = 'gmb_reserve';
}

export class UTMMediumTypes {
  static EMAIL = 'email';

  static SMS = 'sms';
}
